import { ChangePasswordComponent } from '@ebw-monorepo/login';
import { MatDialog } from '@angular/material/dialog';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UserProfileConfig } from '../models/config-user-profile.model';
import { UserProfileService } from '../services/user-profile.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ebw-user-profile-menu',
  templateUrl: './user-profile-menu.component.html',
  styleUrls: ['./user-profile-menu.component.scss']
})
export class UserProfileMenuComponent implements OnChanges {
  @Input() public userInfo: UserProfileConfig | null = null;
  @Input() public userId: any = null;
  @Input() public urlChangePassword: any = null;
  @Input() public homePageRoute: string = '/map';
  @Input() public profilePageRoute: string[] = ['/profile'];

  userData: any;

  constructor(private userProfileService: UserProfileService, private dialog: MatDialog, private _router: Router) {}

  ngOnChanges(chages: SimpleChanges): void {
    const userHasChanged = chages.userInfo;

    this.userProfileService.userData$.subscribe((data) => {
      this.userData = data;
    });

    if (userHasChanged) {
      this.userProfileService.setUserProperties(this.userInfo);
    }
  }

  public changePassword(event: MouseEvent) {
    event.stopPropagation();
    const ref = this.dialog.open(ChangePasswordComponent, {
      disableClose: true,
      hasBackdrop: true,
      width: '30%',
      data: {
        user_id: this.userId,
        url: this.urlChangePassword,
        expiredDate: this.userInfo?.expired
      }
    });
  }

  public goToProfile(event: MouseEvent) {
    event.stopPropagation();
    //workaround per pulire la rotta dal router outlet ausiliare per il portale-saas
    this._router
      .navigate([this.homePageRoute, { outlets: { sidebarAction: null } }])
      .then(() => this._router.navigate(this.profilePageRoute));
  }
}
